<template>
  <div>
    <language-tabs
      ref="languageTabs"
      v-model="form.translations"
      :errors="errors.translations"
      #default="{ translation, index, language, on, ...other }"
      eager
    >
      <concierge-info-form
        :value="translation"
        :language-id="language.id"
        :readonly="readonly"
        v-bind="other"
        v-on="on"
        @update-prop="updateValue(...arguments, `translations.${index}`)"
        @valid="setValid(`translations.${index}`, $event)"
      />
    </language-tabs>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import ConciergeInfoForm from '@/modules/building_complexes/components/forms/ConciergeInfoForm';
import LanguageTabs from '@/modules/_global/_components/LanguageTabs';

import multiValid from '@/modules/_global/mixins/multiple-valid';

export default {
  name: 'ConciergeInfoTabForm',

  components: {
    LanguageTabs,
    ConciergeInfoForm
  },

  mixins: [formEditable, multiValid],

  data() {
    return {
      form: {
        translations: []
      }
    };
  },

  methods: {}
};
</script>
